import React, { useEffect, useState } from "react";
import divider from "../../../../images/Vector 11.png";
import view from "../../../../images/view.png";
import edit from "../../../../images/edit.png";
import axios from "axios";
import { useSelector } from "react-redux";
import deleteicon from "../../../../images/delete (2).png";
import { Link, useNavigate } from "react-router-dom";
import SellerNavigationComponent from "./SellerNavigationComponent";
import "./orders.scss";

const baseUrl = process.env.REACT_APP_BASEURL;
const Products = () => {
  const [details, setDetails] = useState("");
  const [productlist, setProductlist] = useState([]);
  const state = useSelector((state) => state.sellers);
  const [image, setImage] = useState("");
  const [image1, setImage1] = useState("");
  const [image2, setImage2] = useState("");
  const [image3, setImage3] = useState("");
  const { sellerAuth } = state;
  const navigate = useNavigate();
  const [sellers, setSellers] = useState("");

  useEffect(() => {
    const seller=  localStorage.getItem("sellerregisterInfo");
    const sellerInfoObject = JSON.parse(seller);
    console.log(sellerInfoObject?._id); // Check the entire object
  
    const fetchDetails = async () => {
      const response = await axios.post(
        `${baseUrl}/api/reseller/singleuserdetail`,
        {
          reseller:sellerInfoObject?._id,
        }
      );
      setDetails(response.data);
      console.log(sellerAuth?._id, "llll");
    };
    fetchDetails();
  }, []);
  console.log(sellers?._id, "sellerAuth?._id");
  // useEffect(()=>{
  //   const item = localStorage.getItem('sellerregisterInfo');
  //   console.log(item,'sellerregisterInfo');

  //   setSellers(JSON.parse(item))
  // },[]);
  useEffect(() => {
    let productslist;
    const item = localStorage.getItem("sellerregisterInfo");
    console.log(item, "sellerregisterInfo");

    productslist = JSON.parse(item);
    const fetchAllproductswithseller = async () => {
      const response = await axios.get(
        `${baseUrl}/api/Ecomproduct/allsellerproduct/${productslist?._id}`
      );
      setProductlist(response.data);
      console.log(response.data, "llll");
    };
    fetchAllproductswithseller();
  }, []);

  const getCurrentDate = () => {
    const options = {
      weekday: "short",
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    const currentDate = new Date().toLocaleDateString(undefined, options);
    return currentDate;
  };
  const [showModal, setShowModal] = useState(false); // State for showing/hiding the modal
  const [selectedProduct, setSelectedProduct] = useState(null);
  const handleViewClick = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };
  const [showImageEditModal, setShowImageEditModal] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [productData, setProductData] = useState("");

  const fetchProductData = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/Ecomproduct/${selectedProductId}`
      );
      setProductData(response.data);
      console.log(response.data, "response.data");
    } catch (error) {
      console.error("Failed to fetch product data", error);
    }
  };
  useEffect(() => {
    fetchProductData();
  }, []);

  const handleImageedit = (id) => {
    const fetchProductData = async () => {
      try {
        const response = await axios.get(`${baseUrl}/api/Ecomproduct/${id}`);
        setProductData(response.data);
        console.log(response.data, "response.data");
      } catch (error) {
        console.error("Failed to fetch product data", error);
      }
    };

    console.log(id, "dd");
    fetchProductData();

    setSelectedProductId(id);
    setShowImageEditModal(true);
  };
  const handleimagedelete = async (value) => {
    console.log(value, "value");
    const response = await axios.delete(
      `${baseUrl}/api/Ecomproduct/adminproductdelete/${selectedProductId}/${value}`
    );

    fetchProductData();
  };
  const handleFormSubmit = async (event) => {
    event.preventDefault();
    try {
      let value1 = 1;
      const formData = new FormData();
      const newImage = document.getElementById("image").files[0];
      const newImage1 = document.getElementById("image1").files[0];
      const newImage2 = document.getElementById("image2").files[0];
      const newImage3 = document.getElementById("image3").files[0];

      if (image) {
        formData.append("image", newImage);
        formData.append("value", 0);
      } else if (image1) {
        formData.append("image", newImage1);
        formData.append("value", 1);
      } else if (image2) {
        formData.append("image", newImage2);
        formData.append("value", 2);
      } else if (image3) {
        formData.append("image", newImage3);
        formData.append("value", 3);
      }

      const response = await axios.put(
        `${baseUrl}/api/Ecomproduct/adminproductedit/${selectedProductId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      fetchProductData();
      // window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };
  console.log(selectedProductId, "selectedProductId");
  return (
    <div>
      <div style={{ display: "flex" }}>
        <SellerNavigationComponent />
        <img src={divider} className="divider" />
        <div>
          <p className="welcometext">Welcome, {details[0]?.Fullname}</p>
          <p className="todaysdate">{getCurrentDate()}</p>
          {/* <div className="allproductsdiv"> */}
            <p className="allproductstext">All Products</p>
            {/* <table style={{ marginLeft: "50px", marginTop: "20px" }}>
              <thead>
                <tr>
                  <th className="orderdetailstext">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Product
                    Name&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </th>
                  <th className="orderdetailstext">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SKU&nbsp;&nbsp;&nbsp;&nbsp;
                  </th>
                  <th className="orderdetailstext">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Stock&nbsp;&nbsp;&nbsp;&nbsp;
                  </th>
                  <th className="orderdetailstext">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Publish&nbsp;&nbsp;&nbsp;&nbsp;
                  </th>
                  <th className="orderdetailstext">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Options&nbsp;&nbsp;&nbsp;&nbsp;
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {productlist?.map((item, index) => (
                      <p className="numbertext">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {item?.EcomproductName}
                      </p>
                    ))}
                  </td>
                  <td className="numbertext">
                    {productlist?.map((item, index) => (
                      <p>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {item?.sku}&nbsp;
                      </p>
                    ))}
                  </td>
                  <td className="numbertext">
                    {productlist?.map((item, index) => (
                      <p>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {item?.Ecomstock}
                      </p>
                    ))}
                  </td>
                  <td className="numbertext">
                    {productlist?.map((item, index) => (
                      <p>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;kkkk
                      </p>
                    ))}
                  </td>
                  <td className="numbertext">
                    {productlist?.map((item, index) => (
                      <>
                        <div>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <img src={view} />
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <img src={edit} />
                        </div>
                      </>
                    ))}
                  </td>
                </tr>
              </tbody>
            </table> */}
            <table className="bordered-table">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Product Name</th>
                  <th>SKU</th>
                  <th>Stock</th>
                  <th className="options">Options</th>
                </tr>
              </thead>
              <tbody>
                {productlist?.map((item, index) => (
                  <>
                    <tr>
                      <td>{index + 1}</td>
                      <td>{item?.EcomproductName}</td>
                      <td>{item?.sku}</td>
                      <td>{item?.Ecomstock}</td>
                      <td>
                        <button
                          style={{
                            marginLeft: "170px",
                            backgroundColor: "cornflowerblue",
                            borderRadius: "8px",
                            color: "white",
                            width: "100px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleViewClick(item);
                          }}
                        >
                          view
                        </button>
                        <button
                          style={{
                            marginLeft: "170px",
                            backgroundColor: "orange",
                            color: "white",
                            borderRadius: "8px",
                            width: "100px",
                          }}
                          onClick={() => {
                            navigate(`/productedit/${item?._id}`);
                          }}
                        >
                          Edit
                        </button>
                        {/* <button
                          style={{
                            marginLeft: "170px",
                            backgroundColor: "orange",
                            borderRadius: "8px",
                            width: "100px",
                          }}
                          onClick={()=>{handleImageedit(item?._id)}}
                        >
                          Image-edit
                        </button> */}
                        {!item?.properties || item.properties.length === 0 ? (
                            <button
                              style={{
                                marginLeft: "170px",
                                backgroundColor: "rgb(25 93 241)",
                                color: "white",
                                borderRadius: "8px",
                                width: "100px",
                              }}
                              onClick={() => {
                                handleImageedit(item?._id);
                              }}
                            >
                              Some Other Action
                            </button>
                        
                        ) : (
                          <Link to={`/productimageedit/${item?._id}`}>
                            <button
                              style={{
                                marginLeft: "170px",
                                backgroundColor: "green",
                                color: "white",
                                borderRadius: "8px",
                                width: "100px",
                              }}
                            >
                              image-Edit
                            </button>{" "}
                          </Link>
                        )}
                      </td>
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
            {showImageEditModal && selectedProductId && (
              <div className="popup-screen">
                <div className="popup-position">
                  <div
                    style={{
                      background: "white",
                      marginTop: "100px",
                      width: "150%",
                    }}
                  >
                    <button className="close-buttonOne "
                  style={{ alignSelf: "flex-end" }}
                  onClick={() => setShowImageEditModal(false)}
                >
                  Close
                </button>
                    <div style={{ display: "flex" }}>
                      {productData?.image && productData?.image[0] && (
                        <div className="ecomproductdetailsleftarrowdiv">
                          <img
                            src={productData?.image[0]}
                            style={{ height: "100px" }}
                            className="ecomproductdetailslimagediv"
                          />
                          <div
                            onClick={() => {
                              handleimagedelete(0);
                            }}
                          >
                            <img
                              src={deleteicon}
                              style={{
                                cursor: "pointer",
                                width: "20px",
                                margin: "40px",
                              }}
                            />
                          </div>
                        </div>
                      )}

                      {productData?.image && productData?.image[1] && (
                        <div className="ecomproductdetailsleftarrowdiv">
                          <img
                            src={productData?.image[1]}
                            style={{ height: "100px" }}
                            className="ecomproductdetailslimagediv"
                          />
                          <div
                            onClick={() => {
                              handleimagedelete(1);
                            }}
                          >
                            <img
                              src={deleteicon}
                              style={{
                                cursor: "pointer",
                                width: "20px",
                                margin: "40px",
                              }}
                            />
                          </div>
                        </div>
                      )}
                      {productData?.image && productData?.image[2] && (
                        <div className="ecomproductdetailsleftarrowdiv">
                          <img
                            src={productData?.image[2]}
                            style={{ height: "100px" }}
                            className="ecomproductdetailslimagediv"
                          />
                          <div
                            onClick={() => {
                              handleimagedelete(2);
                            }}
                          >
                            <img
                              src={deleteicon}
                              style={{
                                cursor: "pointer",
                                width: "20px",
                                margin: "40px",
                              }}
                            />
                          </div>
                        </div>
                      )}
                      {productData?.image && productData?.image[3] && (
                        <div className="ecomproductdetailsleftarrowdiv">
                          <img
                            src={productData?.image[3]}
                            style={{ height: "100px" }}
                            className="ecomproductdetailslimagediv"
                          />
                          <div
                            onClick={() => {
                              handleimagedelete(3);
                            }}
                          >
                            <img
                              src={deleteicon}
                              style={{
                                cursor: "pointer",
                                width: "20px",
                                margin: "40px",
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div style={{ display: "flex" }}>
                      <form onSubmit={handleFormSubmit}>
                        <div>
                          <div style={{ display: "flex" }}>
                            <input
                              type="file"
                              placeholder="Enter image"
                              id="image"
                              name="image"
                              value={image}
                              onChange={(event) => setImage(event.target.value)}
                            />
                            <input
                              type="file"
                              placeholder="Enter image"
                              id="image1"
                              name="image1"
                              value={image1}
                              onChange={(event) =>
                                setImage1(event.target.value)
                              }
                            />
                            <input
                              type="file"
                              placeholder="Enter image"
                              id="image2"
                              name="image2"
                              value={image2}
                              onChange={(event) =>
                                setImage2(event.target.value)
                              }
                            />
                            <input
                              type="file"
                              placeholder="Enter image"
                              id="image3"
                              name="image3"
                              value={image3}
                              onChange={(event) =>
                                setImage3(event.target.value)
                              }
                            />
                          </div>

                          <div style={{ color: "blue" }}>
                            <button className="SubmitButton"
                              // style={{
                              //   backgroundColor: "lightblue",
                              //   color: "darkblue",
                              //   border: "1px solid blue",
                              // }}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {showModal && selectedProduct && (
              <div className="popup-screen">
                <div className="popup-position">
                  <div
                    style={{
                      // marginTop: "100px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <button className="close-button "
                      style={{ alignSelf: "flex-end" }}
                      onClick={() => setShowModal(false)}
                    >
                      Close
                    </button>
                    <div style={{ backgroundColor: "white" }}>
                      <h2>Product Details</h2>
                      <div className="ecomproductdetailsimagecontainer">
                        {selectedProduct?.image ? (
                          <>
                            {selectedProduct?.image &&
                              selectedProduct?.image?.length > 0 && (
                                <img
                                  alt=""
                                  src={selectedProduct?.image[0]}
                                  className="ecomproductdetailsfullimage"
                                />
                              )}
                          </>
                        ) : (
                          <>
                            {selectedProduct?.properties &&
                              selectedProduct?.properties[0]?.image[0] && (
                                <img
                                  alt=""
                                  src={selectedProduct?.properties[0]?.image[0]}
                                  className="ecomproductdetailsfullimage"
                                />
                              )}
                          </>
                        )}

                        {selectedProduct?.image ? (
                          <>
                            {selectedProduct?.image &&
                              selectedProduct?.image?.length > 0 && (
                                <img
                                  alt=""
                                  src={selectedProduct?.image[1]}
                                  className="ecomproductdetailsfullimage"
                                />
                              )}
                          </>
                        ) : (
                          <>
                            {selectedProduct?.properties &&
                              selectedProduct?.properties[1]?.image[0] && (
                                <img
                                  alt=""
                                  src={selectedProduct?.properties[1]?.image[0]}
                                  className="ecomproductdetailsfullimage"
                                />
                              )}
                          </>
                        )}

                        {selectedProduct?.image ? (
                          <>
                            {selectedProduct?.image &&
                              selectedProduct?.image?.length > 0 && (
                                <img
                                  alt=""
                                  src={selectedProduct?.image[2]}
                                  className="ecomproductdetailsfullimage"
                                />
                              )}
                          </>
                        ) : (
                          <>
                            {selectedProduct?.properties &&
                              selectedProduct?.properties[2]?.image[0] && (
                                <img
                                  alt=""
                                  src={selectedProduct?.properties[2]?.image[0]}
                                  className="ecomproductdetailsfullimage"
                                />
                              )}
                          </>
                        )}
                        {selectedProduct?.image ? (
                          <>
                            {selectedProduct?.image &&
                              selectedProduct?.image?.length > 0 && (
                                <img
                                  alt=""
                                  src={selectedProduct?.image[3]}
                                  className="ecomproductdetailsfullimage"
                                />
                              )}
                          </>
                        ) : (
                          <>
                            {selectedProduct?.properties &&
                              selectedProduct?.properties[3]?.image[0] && (
                                <img
                                  alt=""
                                  src={selectedProduct?.properties[3]?.image[0]}
                                  className="ecomproductdetailsfullimage"
                                />
                              )}
                          </>
                        )}
                      </div>

                      {/* <img src={selectedProduct?.image[0]} style={{width:"30px"}}/>
                    <img src={selectedProduct?.image[1]} style={{width:"30px"}}/>
                    <img src={selectedProduct?.image[2]} style={{width:"30px"}}/>
                    <img src={selectedProduct?.image[3]} style={{width:"30px"}}/> */}

                      <p>Name: {selectedProduct.EcomproductName}</p>
                      <p>
                        Category: {selectedProduct?.Ecomcategory?.Ecomcategory}
                      </p>
                      <p>
                        Sub-Category:{" "}
                        {selectedProduct?.Ecomsubcategory?.Ecomsubcategory}
                      </p>
                      <p>
                        Newsub-Category:{" "}
                        {
                          selectedProduct?.Ecomnewsubcategory
                            ?.Ecomnewsubcategory
                        }
                      </p>
                      <p>Brand: {selectedProduct?.Ecombrand?.brand}</p>
                      <p>Stock: {selectedProduct?.Ecomstock}</p>
                      <p>DeliveryCharge: {selectedProduct?.deliveryCharge}</p>
                      <p>FixedFee: {selectedProduct?.fixedFee}</p>
                      <p>OnstaraFee : {selectedProduct?.onstaraFee}</p>

                      <p>SellingPrice : {selectedProduct?.sellingPrice}</p>

                      <p>Specification : {selectedProduct?.specification}</p>
                      <p>Description : {selectedProduct?.Ecomdescription}</p>

                      {/* Add more details here */}
                    </div>
                  </div>
                </div>
              </div>
            )}
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default Products;
